import { createReferenceAdapter } from '../../base';
import type { VariableReference } from './variables.schema';

const references: VariableReference[] = [
  'functions',
  'delayResponses',
  'flowSteps',
  'flowNoCodeSteps',
  'flowFunctions',
  'topics',
  'behaviours',
  'greetings',
  'roles',
  'personalities',
  'sms',
  'startFunctions',
  'endFunctions',
];

export const variablesReferencesAdapter = createReferenceAdapter(references);
